"use strict";
var TO_STRING_TAG_SUPPORT = require("../internals/to-string-tag-support");
var classof = require("../internals/classof");
module.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
  return "[object " + classof(this) + "]";
};
